import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";
import CommonForm from "Components/Common/CommonForm";
import TruncatedText from "Components/Common/TruncatedText";
import {
  loadCodelistsDetailId,
} from "api/modules/common.option";
import { activityFormFields } from "../helper/ambulatoryvisitconstants";

interface ActivityConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (values: any) => void;
  editingActivity: any;
}

const ActivityConfigModal: React.FC<ActivityConfigModalProps> = ({
  isOpen,
  onClose,
  onSave,
  editingActivity
}) => {
  const [optionsLoaded, setOptionsLoaded] = React.useState(false);

  useEffect(() => {
    const fetchOptions = async () => {
      await loadCodelistsDetailId(["AMBULATORY_VISIT_ACTIVITY_CATEGORY_OPTIONS"]);
      setOptionsLoaded(true);
    };
    fetchOptions();
  }, []);

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm<any>({
    defaultValues: {
      activityname: "",
      activitydescription: "",
      activitycategory: "",
      estimateddurationminutes: "",
      ismandatory: true
    },
    mode: "onChange"
  });

  useEffect(() => {
    if (isOpen && optionsLoaded) {
      if (editingActivity) {
        reset({
          activityname: editingActivity.activityname || "",
          activitydescription: editingActivity.activitydescription || "",
          activitycategory:  editingActivity.activitycategory || "",
          estimateddurationminutes: editingActivity.estimateddurationminutes || "",
          ismandatory: editingActivity.ismandatory !== false
        });
      } else {
        reset({
          activityname: "",
          activitydescription: "",
          activitycategory: "",
          estimateddurationminutes: "",
          ismandatory: true
        });
      }
    }
  }, [isOpen, editingActivity, reset, optionsLoaded]);

  const handleSave = (values: any) => {
    onSave({
      ...values,
    });
  };

  return (

    <Modal
      isOpen={isOpen}
      toggle={onClose}
      size="lg"
      backdrop="static"
      className="common_modal"
      centered
    >

      <ModalHeader toggle={onClose} className="fw-bold border-bottom p-3">
        {editingActivity ? (
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            Edit Activity Details
            <TruncatedText text={`(${editingActivity.activityname})`} maxWidth="400px" />
          </span>
        ) : (
          "Add Visit Activity"
        )}
      </ModalHeader>

      <ModalBody>
        {!optionsLoaded ? (
          <div className="d-flex align-items-center justify-content-center py-4">
            <Spinner color="primary" />
          </div>
        ) : (
          <CommonForm
            fields={activityFormFields}
            control={control}
            errors={errors}
            columns={2}
          />
        )}
      </ModalBody>

      {/* Footer */}
      <ModalFooter className="bg-white border-top">
        <Button outline onClick={onClose}>
          Cancel
        </Button>

        <Button
          color="primary"
          outline
          onClick={handleSubmit(handleSave)}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ActivityConfigModal;
